import { connectedStore } from '../../store';
import selectors from '../selectors';

const getMainLocale = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getMainLocale(state);
};

export default getMainLocale;
